module.exports = __webpack_public_path__ + "static/media/matlab.719de27d.png";